import { useSelector } from 'react-redux';
import { Integration } from 'lib/types';
import { RootState } from 'reducers';
import IntegrationList from 'components/IntegrationList/IntegrationList';
import 'styles.scss';

function IntegrationsPage() {
    const integrations = useSelector((state: RootState) => state.integrations);

    // Convert integrations from normalized form to list of Integrations
    const integrationList = Object.keys(integrations.byId).map(
        (key) => integrations.byId[key] as Integration
    );

    return (
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="d-flex justify-content-between align-items-start">
                        <h1 className="msds-text-header-1 msds-text-clear-blue mb-10">
                            Integrations
                        </h1>
                    </div>
                    <IntegrationList integrations={integrationList} />
                </div>
            </div>
        </div>
    );
}

export default IntegrationsPage;
